export default function setTagsList(state, action) {
  state.sidebar.usersList = action.payload;
}
